import { Trash2 } from 'lucide-react';
import { useFormContext } from 'react-hook-form';

import { cn, FormControl, FormField, FormItem } from '@crossnokaye/ux-common';

import { Button } from '@/ux-common/components/button/button';

import { DefrostScheduleBaseCellProps } from './defrost-schedule.types';
import { DefrostTableCell } from './defrost-table-cell';

export const DeleteEventCell: React.FC<DefrostScheduleBaseCellProps> = ({ index }) => {
  const { control, unregister } = useFormContext();

  return (
    <DefrostTableCell>
      {(disabledByPermissions) => (
        <FormField
          control={control}
          name={'defrostSchedule'}
          render={({ field }) => (
            <FormItem className="flex justify-end">
              <FormControl>
                <Button
                  onClick={() => {
                    const currentEvents = field.value ?? [];
                    const filteredEvents = currentEvents.filter(
                      (_: unknown, i: number) => i !== index
                    );

                    // Set the new value first so dirty tracking works correctly
                    field.onChange(filteredEvents);

                    // Defer unregister to next tick — RHF's default shouldUnregister:false
                    // keeps child field registrations after unmount, causing it to
                    // reconstruct removed array entries as {}. Deferring prevents
                    // unregister from resetting dirty state before onChange takes effect.
                    const lastIndex = currentEvents.length - 1;
                    setTimeout(() => {
                      unregister(`defrostSchedule.${lastIndex}.eventDays`);
                      unregister(`defrostSchedule.${lastIndex}.startTime`);
                      unregister(`defrostSchedule.${lastIndex}.endDate`);
                    }, 0);
                  }}
                  className="btn btn-transparent btn-square"
                  disabled={disabledByPermissions}
                >
                  <Trash2
                    className={cn(
                      'glyph glyph-md',
                      disabledByPermissions ? 'text-disabled' : 'text-destructive'
                    )}
                    aria-hidden="true"
                  />
                </Button>
              </FormControl>
            </FormItem>
          )}
        />
      )}
    </DefrostTableCell>
  );
};
